import { Component, OnInit } from '@angular/core';
import { CurrentTenantService } from '@suvo-bi-users';
import { ITitleSectionInformation } from '../../interfaces/title-section-information.interface';

@Component({
  standalone: false,
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  tenant;

  freeTrial = 30;

  showFields = [
    {
      name: 'firstName',
      required: true,
    },
    {
      name: 'lastName',
      required: true,
    },
    {
      name: 'company',
      required: true,
    },
    {
      name: 'phone',
      required: true,
    },
  ];

  registerStatus;

  constructor(private currentTenantService: CurrentTenantService) {}

  ngOnInit() {
    this.tenant = this.currentTenantService.currentTenantData;
    this.freeTrial = this.tenant.autoTrialPeriod;
  }

  onRegisterStatusChange(status) {
    console.log('Register status: ', status);

    this.registerStatus = status;

    if (this.registerStatus == 'REGISTER_ATTEMPT_COMPLETE') {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;

      let matDrawer = document.getElementsByTagName('mat-drawer-content');
      let matSidenav = document.getElementsByTagName('mat-sidenav-content');

      if (matDrawer && matDrawer.length) {
        matDrawer[0].scrollTo(0, 0);
      }

      if (matSidenav && matSidenav.length) {
        matSidenav[0].scrollTo(0, 0);
      }
    }
  }
}
